import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATION_FAILURE,
    GET_LOCATION_REQUEST,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_BY_ID_FAILURE,
    GET_LOCATION_BY_ID_REQUEST,
    GET_LOCATION_BY_ID_SUCCESS,
    GET_UNIT_FAILURE,
    GET_UNIT_REQUEST,
    GET_UNIT_SUCCESS,
    CREATE_APPOINTMENT_FAILURE,
    CREATE_APPOINTMENT_REQUEST,
    CREATE_APPOINTMENT_SUCCESS,
    CLEAR_APPOINTMENT,
    RESET_CREATE_VISITOR_ERROR,
} from '../constants/createAppoinment.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
    locationById: {
        loading: false,
        data: [],
        error: '',
    },
    unit: {
        loading: false,
        data: {},
        error: '',
    },
    createVisitor: {
        loading: false,
        data: {},
        error: '',
    },
};

const createAppoinmentReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_LOCATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_LOCATION_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case GET_LOCATION_BY_ID_REQUEST:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: true,
                    error: '',
                },
            };
        case GET_LOCATION_BY_ID_SUCCESS:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
            };
        case GET_LOCATION_BY_ID_FAILURE:
            return {
                ...state,
                locationById: {
                    ...state.locationById,
                    loading: false,
                    error: action.payload,
                },
            };
        case GET_UNIT_REQUEST:
            return {
                ...state,
                unit: {
                    ...state.unit,
                    loading: true,
                    data: [],
                    error: '',
                },
            };

        case GET_UNIT_SUCCESS:
            return {
                ...state,
                unit: {
                    ...state.unit,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
            };
        case GET_UNIT_FAILURE:
            return {
                ...state,
                unit: {
                    ...state.unit,
                    loading: false,
                    data: {},
                    error: action.payload,
                },
            };
        case CREATE_APPOINTMENT_REQUEST:
            return {
                ...state,
                createVisitor: {
                    ...state.createVisitor,
                    loading: true,
                    error: '',
                },
            };
        case CREATE_APPOINTMENT_SUCCESS:
            return {
                ...state,
                createVisitor: {
                    ...state.createVisitor,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
            };
        case CREATE_APPOINTMENT_FAILURE:
            return {
                ...state,
                createVisitor: {
                    ...state.createVisitor,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };

        case RESET_CREATE_VISITOR_ERROR:
            return {
                ...state,
                createVisitor: {
                    ...state.createVisitor,
                    error: '',
                },
            };

        case CLEAR_APPOINTMENT:
            return {
                ...state,
                createVisitor: {
                    ...state.createVisitor,
                    loading: false,
                    data: [],
                    error: '',
                },
            };
        default:
            return state;
    }
};

export default createAppoinmentReducer;
